import { render } from "./ContactAuth.vue?vue&type=template&id=51954874"
import script from "./ContactAuth.vue?vue&type=script&lang=js"
export * from "./ContactAuth.vue?vue&type=script&lang=js"
script.render = render

export default script